import type { ListenersMap } from "./types";
import type { UserMentionedArgs, UserOrganizationAccessChangedArgs, WorkspaceInvitationDeletedArgs, WorkspaceInvitedArgs } from "@/generated/models";
import { createVoidEventHook } from "./createVoidEventHook";
import { useAxureCloudHub } from "./useAxureCloudHub";

interface Payload {
  userWorkspaceInvited: WorkspaceInvitedArgs;
  userWorkspaceInvitationDeleted: WorkspaceInvitationDeletedArgs;
  userMentioned: UserMentionedArgs;
  userOrganizationAccessChanged: UserOrganizationAccessChangedArgs;
}

export function useAxureCloudNotificationsHub() {
  const userWorkspaceInvited = createVoidEventHook<WorkspaceInvitedArgs>();
  const userWorkspaceInvitationDeleted = createVoidEventHook<WorkspaceInvitationDeletedArgs>();
  const userMentioned = createVoidEventHook<UserMentionedArgs>();
  const userOrganizationAccessChanged = createVoidEventHook<UserOrganizationAccessChangedArgs>();

  const listeners: ListenersMap<Payload> = {
    userWorkspaceInvited: userWorkspaceInvited.trigger,
    userWorkspaceInvitationDeleted: userWorkspaceInvitationDeleted.trigger,
    userMentioned: userMentioned.trigger,
    userOrganizationAccessChanged: userOrganizationAccessChanged.trigger,
  };

  useAxureCloudHub("notifications", {
    listeners,
  });

  return {
    userWorkspaceInvited,
    userWorkspaceInvitationDeleted,
    userMentioned,
    userOrganizationAccessChanged,
  };
}
